// extracted by mini-css-extract-plugin
export var body = "ProductCard-module--body--0cd4a";
export var card = "ProductCard-module--card--3449a";
export var content = "ProductCard-module--content--4fad2";
export var image = "ProductCard-module--image--9220f";
export var m2Xl = "ProductCard-module--m-2xl--88bf8";
export var m2Xs = "ProductCard-module--m-2xs--a70c2";
export var m3Xl = "ProductCard-module--m-3xl--528bb";
export var m3Xs = "ProductCard-module--m-3xs--087bc";
export var m4Xl = "ProductCard-module--m-4xl--b395a";
export var m5Xl = "ProductCard-module--m-5xl--ffca9";
export var m6Xl = "ProductCard-module--m-6xl--b434a";
export var m7Xl = "ProductCard-module--m-7xl--9a7bd";
export var m8Xl = "ProductCard-module--m-8xl--7a29b";
export var mBase = "ProductCard-module--m-base--e4efd";
export var mLg = "ProductCard-module--m-lg--1bd16";
export var mMd = "ProductCard-module--m-md--78a41";
export var mSm = "ProductCard-module--m-sm--d97bf";
export var mXl = "ProductCard-module--m-xl--fb74e";
export var mXs = "ProductCard-module--m-xs--20496";
export var mb2Xl = "ProductCard-module--mb-2xl--f0add";
export var mb2Xs = "ProductCard-module--mb-2xs--2504a";
export var mb3Xl = "ProductCard-module--mb-3xl--ce66c";
export var mb3Xs = "ProductCard-module--mb-3xs--f0385";
export var mb4Xl = "ProductCard-module--mb-4xl--d205d";
export var mb5Xl = "ProductCard-module--mb-5xl--6f180";
export var mb6Xl = "ProductCard-module--mb-6xl--b9969";
export var mb7Xl = "ProductCard-module--mb-7xl--ad9ab";
export var mb8Xl = "ProductCard-module--mb-8xl--37f76";
export var mbBase = "ProductCard-module--mb-base--c7431";
export var mbLg = "ProductCard-module--mb-lg--0bad3";
export var mbMd = "ProductCard-module--mb-md--d805b";
export var mbSm = "ProductCard-module--mb-sm--40e7f";
export var mbXl = "ProductCard-module--mb-xl--76df0";
export var mbXs = "ProductCard-module--mb-xs--3fb2c";
export var ml2Xl = "ProductCard-module--ml-2xl--dc06f";
export var ml2Xs = "ProductCard-module--ml-2xs--0b68e";
export var ml3Xl = "ProductCard-module--ml-3xl--3c755";
export var ml3Xs = "ProductCard-module--ml-3xs--8ab55";
export var ml4Xl = "ProductCard-module--ml-4xl--2a7e5";
export var ml5Xl = "ProductCard-module--ml-5xl--f8eaf";
export var ml6Xl = "ProductCard-module--ml-6xl--3dd33";
export var ml7Xl = "ProductCard-module--ml-7xl--40432";
export var ml8Xl = "ProductCard-module--ml-8xl--93b85";
export var mlBase = "ProductCard-module--ml-base--5bb18";
export var mlLg = "ProductCard-module--ml-lg--3365f";
export var mlMd = "ProductCard-module--ml-md--12b67";
export var mlSm = "ProductCard-module--ml-sm--a6d31";
export var mlXl = "ProductCard-module--ml-xl--315ef";
export var mlXs = "ProductCard-module--ml-xs--d6938";
export var mr2Xl = "ProductCard-module--mr-2xl--2f922";
export var mr2Xs = "ProductCard-module--mr-2xs--fe7db";
export var mr3Xl = "ProductCard-module--mr-3xl--3dc9b";
export var mr3Xs = "ProductCard-module--mr-3xs--e1c27";
export var mr4Xl = "ProductCard-module--mr-4xl--697d2";
export var mr5Xl = "ProductCard-module--mr-5xl--1f8cf";
export var mr6Xl = "ProductCard-module--mr-6xl--0af63";
export var mr7Xl = "ProductCard-module--mr-7xl--98338";
export var mr8Xl = "ProductCard-module--mr-8xl--57b4b";
export var mrBase = "ProductCard-module--mr-base--3277a";
export var mrLg = "ProductCard-module--mr-lg--760b6";
export var mrMd = "ProductCard-module--mr-md--30870";
export var mrSm = "ProductCard-module--mr-sm--33f7c";
export var mrXl = "ProductCard-module--mr-xl--5552f";
export var mrXs = "ProductCard-module--mr-xs--106d4";
export var mt2Xl = "ProductCard-module--mt-2xl--d6a15";
export var mt2Xs = "ProductCard-module--mt-2xs--34928";
export var mt3Xl = "ProductCard-module--mt-3xl--168dc";
export var mt3Xs = "ProductCard-module--mt-3xs--65b8b";
export var mt4Xl = "ProductCard-module--mt-4xl--04981";
export var mt5Xl = "ProductCard-module--mt-5xl--43738";
export var mt6Xl = "ProductCard-module--mt-6xl--0a5b7";
export var mt7Xl = "ProductCard-module--mt-7xl--44d7a";
export var mt8Xl = "ProductCard-module--mt-8xl--975d1";
export var mtBase = "ProductCard-module--mt-base--e5920";
export var mtLg = "ProductCard-module--mt-lg--d3831";
export var mtMd = "ProductCard-module--mt-md--7c056";
export var mtSm = "ProductCard-module--mt-sm--31fa7";
export var mtXl = "ProductCard-module--mt-xl--0d27b";
export var mtXs = "ProductCard-module--mt-xs--27349";
export var p2Xl = "ProductCard-module--p-2xl--0ef80";
export var p2Xs = "ProductCard-module--p-2xs--d57d7";
export var p3Xl = "ProductCard-module--p-3xl--269fd";
export var p3Xs = "ProductCard-module--p-3xs--212a1";
export var p4Xl = "ProductCard-module--p-4xl--4666e";
export var p5Xl = "ProductCard-module--p-5xl--d4655";
export var p6Xl = "ProductCard-module--p-6xl--a798d";
export var p7Xl = "ProductCard-module--p-7xl--88e6b";
export var p8Xl = "ProductCard-module--p-8xl--e4b59";
export var pBase = "ProductCard-module--p-base--adf50";
export var pLg = "ProductCard-module--p-lg--92e93";
export var pMd = "ProductCard-module--p-md--19bb6";
export var pSm = "ProductCard-module--p-sm--319b1";
export var pXl = "ProductCard-module--p-xl--e4a88";
export var pXs = "ProductCard-module--p-xs--4c6ca";
export var paragraph = "ProductCard-module--paragraph--ba7df";
export var paragraphSm = "ProductCard-module--paragraph-sm--eb74d";
export var paragraphXs = "ProductCard-module--paragraph-xs--a44fa";
export var pb2Xl = "ProductCard-module--pb-2xl--8c336";
export var pb2Xs = "ProductCard-module--pb-2xs--7040e";
export var pb3Xl = "ProductCard-module--pb-3xl--0d6fe";
export var pb3Xs = "ProductCard-module--pb-3xs--a29d9";
export var pb4Xl = "ProductCard-module--pb-4xl--56222";
export var pb5Xl = "ProductCard-module--pb-5xl--b4a22";
export var pb6Xl = "ProductCard-module--pb-6xl--3ab5b";
export var pb7Xl = "ProductCard-module--pb-7xl--702e4";
export var pb8Xl = "ProductCard-module--pb-8xl--4ac64";
export var pbBase = "ProductCard-module--pb-base--c47bd";
export var pbLg = "ProductCard-module--pb-lg--33562";
export var pbMd = "ProductCard-module--pb-md--7d3d0";
export var pbSm = "ProductCard-module--pb-sm--4be9b";
export var pbXl = "ProductCard-module--pb-xl--45554";
export var pbXs = "ProductCard-module--pb-xs--ba949";
export var pl2Xl = "ProductCard-module--pl-2xl--73792";
export var pl2Xs = "ProductCard-module--pl-2xs--19478";
export var pl3Xl = "ProductCard-module--pl-3xl--fbd58";
export var pl3Xs = "ProductCard-module--pl-3xs--0b825";
export var pl4Xl = "ProductCard-module--pl-4xl--6c16e";
export var pl5Xl = "ProductCard-module--pl-5xl--6c969";
export var pl6Xl = "ProductCard-module--pl-6xl--a4bf3";
export var pl7Xl = "ProductCard-module--pl-7xl--25a48";
export var pl8Xl = "ProductCard-module--pl-8xl--c6e91";
export var plBase = "ProductCard-module--pl-base--85844";
export var plLg = "ProductCard-module--pl-lg--d2f81";
export var plMd = "ProductCard-module--pl-md--e8a58";
export var plSm = "ProductCard-module--pl-sm--e399e";
export var plXl = "ProductCard-module--pl-xl--c47fa";
export var plXs = "ProductCard-module--pl-xs--858d9";
export var pr2Xl = "ProductCard-module--pr-2xl--d07ea";
export var pr2Xs = "ProductCard-module--pr-2xs--17b78";
export var pr3Xl = "ProductCard-module--pr-3xl--51a24";
export var pr3Xs = "ProductCard-module--pr-3xs--70cf8";
export var pr4Xl = "ProductCard-module--pr-4xl--2b5bb";
export var pr5Xl = "ProductCard-module--pr-5xl--71406";
export var pr6Xl = "ProductCard-module--pr-6xl--e09eb";
export var pr7Xl = "ProductCard-module--pr-7xl--ca034";
export var pr8Xl = "ProductCard-module--pr-8xl--8e520";
export var prBase = "ProductCard-module--pr-base--5a696";
export var prLg = "ProductCard-module--pr-lg--1c6bd";
export var prMd = "ProductCard-module--pr-md--39cdf";
export var prSm = "ProductCard-module--pr-sm--3da2d";
export var prXl = "ProductCard-module--pr-xl--415d0";
export var prXs = "ProductCard-module--pr-xs--467f8";
export var pt2Xl = "ProductCard-module--pt-2xl--019a8";
export var pt2Xs = "ProductCard-module--pt-2xs--69c92";
export var pt3Xl = "ProductCard-module--pt-3xl--2433f";
export var pt3Xs = "ProductCard-module--pt-3xs--e18a0";
export var pt4Xl = "ProductCard-module--pt-4xl--0b181";
export var pt5Xl = "ProductCard-module--pt-5xl--4feb9";
export var pt6Xl = "ProductCard-module--pt-6xl--424dc";
export var pt7Xl = "ProductCard-module--pt-7xl--c095d";
export var pt8Xl = "ProductCard-module--pt-8xl--f4112";
export var ptBase = "ProductCard-module--pt-base--1f3e9";
export var ptLg = "ProductCard-module--pt-lg--64744";
export var ptMd = "ProductCard-module--pt-md--9df27";
export var ptSm = "ProductCard-module--pt-sm--0ef79";
export var ptXl = "ProductCard-module--pt-xl--de5d3";
export var ptXs = "ProductCard-module--pt-xs--b9ead";
export var title = "ProductCard-module--title--133e8";
export var titleH1 = "ProductCard-module--title-h1--85655";
export var titleH1Alt = "ProductCard-module--title-h1--alt--252d8";
export var titleH2 = "ProductCard-module--title-h2--6bf09";
export var titleH2Alt = "ProductCard-module--title-h2--alt--67bef";
export var titleH3 = "ProductCard-module--title-h3--53fef";
export var titleH3Alt = "ProductCard-module--title-h3--alt--5e031";
export var titleH4 = "ProductCard-module--title-h4--8b01f";
export var titleH4Alt = "ProductCard-module--title-h4--alt--d0b9d";
export var titleH5 = "ProductCard-module--title-h5--01f27";